import React from 'react';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import {Typography} from '@material-ui/core';
import colors from "../../theme/colors";

const sizeStyles = {
	small: {valueContainer: {padding: "0 6px"}, indicators: {padding: "2px 4px"}},
	medium: {valueContainer: {padding: "0 8px"}, indicators: {padding: "4px 6px"}},
	large: {valueContainer: {padding: "0 10px"}, indicators: {padding: "6px 8px"}},
};

const animatedComponents = makeAnimated();

const SelectAndSearchComponent = ({
		options = [],
		value,
		onChange,
		placeholder = "Select an option",
		getOptionValue = (opt) => opt.name,
		getOptionLabel = (opt) => (
			<div style={{display: "flex", alignItems: "center", gap: "5px", width: '100%'}}>
				{(opt.logo || opt.image) && (
					<img
						src={opt.logo || opt.image}
						alt={opt.name}
						style={{width: "20px", objectFit: "contain", borderRadius: '50%'}}
					/>
				)}
				<span style={{width: "100%"}}>{opt.name}</span>
			</div>
		),
		size = "medium",
		isMulti = false,
		error = "", // pass error message from Formik
		styles: customStyles, // accept custom styles
	}) => {

	return (
		<div style={{zIndex: 9999999}}>
			<Select
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				options={options}
				isClearable
				isSearchable
				getOptionValue={getOptionValue}
				getOptionLabel={getOptionLabel}
				components={animatedComponents}
				isMulti={isMulti}
				style={{height: "100%"}}
				className="basic-multi-select"
				classNamePrefix="select"
				styles={{
					control: (base, state) => ({
						...base,
						minHeight: 40,
						borderColor: error ? '#f44336' : state.isFocused ? colors.primary : base.borderColor,
						boxShadow: error
							? '0 0 0 0.2px #f44336'
							: state.isFocused
								? '0 0 0 1px #9cc54b'
								: base.boxShadow,
						"&:hover": {borderColor: error ? '#f44336' : colors.primary},
						borderRadius: 4,
						valueContainer: {
							...base.valueContainer,
							padding: sizeStyles[size].valueContainer.padding,
						},
						indicatorsContainer: {
							...base.indicatorsContainer,
							padding: sizeStyles[size].indicators.padding,
						},
						...(customStyles?.control ? customStyles.control(base, state) : {}),
					}),
					option: (base, state) => ({
						...base,
						backgroundColor: state.isFocused
							? "#eaf6d4"
							: state.isSelected
								? colors.primary
								: base.backgroundColor,
						color: state.isSelected ? "white" : base.color,
						...(customStyles?.option ? customStyles.option(base, state) : {}),
					}),
					multiValue: (base) => ({
						...base,
						backgroundColor: "#9cc54b22",
						...(customStyles?.multiValue ? customStyles.multiValue(base) : {}),
					}),
					multiValueLabel: (base) => ({
						...base,
						color: colors.primary,
						...(customStyles?.multiValueLabel ? customStyles.multiValueLabel(base) : {}),
					}),
					multiValueRemove: (base) => ({
						...base,
						color: colors.primary,
						padding: "0 4px",
						":hover": {backgroundColor: colors.primary, color: "white"},
						...(customStyles?.multiValueRemove ? customStyles.multiValueRemove(base) : {}),
					}),
					menu: (base) => ({
						...base,
						...(customStyles?.menu ? customStyles.menu(base) : {}),
					}),
					valueContainer: (base) => ({
						...base,
						...(customStyles?.valueContainer ? customStyles.valueContainer(base) : {}),
					}),
					input: (base) => ({
						...base,
						...(customStyles?.input ? customStyles.input(base) : {}),
					}),
				}}
			/>
			{error && (
				<Typography
					variant="caption"
					style={{
						color: "#f44336",
						marginTop: 4,
						display: "block",
						fontSize: "0.75rem",
					}}
				>
					{error}
				</Typography>
			)}
		</div>
	);
};

export default SelectAndSearchComponent;
